import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { RoutePath } from '@constants/route-path';
import { auth } from '@src/firebase/firebase';
import { useAuth } from '../contexts/authContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { userLoggedIn, loading } = useAuth();

  if (!userLoggedIn && !loading) {
    return <Navigate to={RoutePath.LoginPage} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
